var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  50% {\n    transform: scale(0.9);\n  }\n'], ['\n  50% {\n    transform: scale(0.9);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &:first-child {\n    padding-top: 0.4rem;\n  }\n  label {\n    margin: auto;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    span {\n      &.children {\n        max-width: ', ';\n        margin-left: 0px;\n        margin-top: 2px;\n        min-height: 24px;\n      }\n      &:first-child {\n        position: relative;\n        display: inline-block;\n        vertical-align: middle;\n        width: 16px;\n        height: 16px;\n        margin-top: 5px;\n        border-radius: 5px;\n        transform: scale(1);\n        border: ', ' solid #ccc;\n        transition: all .2s ease;\n        float: left;\n        svg {\n          position: absolute;\n          top: 0px;\n          left: 1px;\n          fill: none;\n          stroke: #FFFFFF;\n          stroke-width: 2;\n          stroke-linecap: round;\n          stroke-linejoin: round;\n          stroke-dasharray: 16px;\n          stroke-dashoffset: 16px;\n          transition: all .3s ease;\n          transition-delpay: .1s;\n          transform: translate3d(0,0,0);\n        }\n        &:before {\n          content: "";\n          width: 100%;\n          height: 100%;\n          background: ', ';\n          display: block;\n          transform: scale(0);\n          opacity: 1;\n          border-radius: 50%;\n        }\n      }\n      &:last-child {\n        display: block;\n        margin-bottom: 0px;\n        margin-top: 0px;\n        padding-left: 24px;\n        margin-bottom: 0.4rem;\n      }\n    }\n    &:hover span:first-child {\n      border-color: ', ';\n    }\n  }\n\n  input[type=checkbox] {\n    display: none;\n  }\n\n  input[type=checkbox]:checked + label {\n    span {\n      &:first-child {\n        background: ', ';\n        border-color: ', ';\n        animation: ', ' .4s ease;\n        svg {\n          stroke-dashoffset: 0;\n        }\n        &:before {\n          transform: scale(3.5);\n          opacity: 0;\n          transition: all .6s ease;\n        }\n      }\n    }\n  }\n'], ['\n  &:first-child {\n    padding-top: 0.4rem;\n  }\n  label {\n    margin: auto;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    span {\n      &.children {\n        max-width: ', ';\n        margin-left: 0px;\n        margin-top: 2px;\n        min-height: 24px;\n      }\n      &:first-child {\n        position: relative;\n        display: inline-block;\n        vertical-align: middle;\n        width: 16px;\n        height: 16px;\n        margin-top: 5px;\n        border-radius: 5px;\n        transform: scale(1);\n        border: ', ' solid #ccc;\n        transition: all .2s ease;\n        float: left;\n        svg {\n          position: absolute;\n          top: 0px;\n          left: 1px;\n          fill: none;\n          stroke: #FFFFFF;\n          stroke-width: 2;\n          stroke-linecap: round;\n          stroke-linejoin: round;\n          stroke-dasharray: 16px;\n          stroke-dashoffset: 16px;\n          transition: all .3s ease;\n          transition-delpay: .1s;\n          transform: translate3d(0,0,0);\n        }\n        &:before {\n          content: "";\n          width: 100%;\n          height: 100%;\n          background: ', ';\n          display: block;\n          transform: scale(0);\n          opacity: 1;\n          border-radius: 50%;\n        }\n      }\n      &:last-child {\n        display: block;\n        margin-bottom: 0px;\n        margin-top: 0px;\n        padding-left: 24px;\n        margin-bottom: 0.4rem;\n      }\n    }\n    &:hover span:first-child {\n      border-color: ', ';\n    }\n  }\n\n  input[type=checkbox] {\n    display: none;\n  }\n\n  input[type=checkbox]:checked + label {\n    span {\n      &:first-child {\n        background: ', ';\n        border-color: ', ';\n        animation: ', ' .4s ease;\n        svg {\n          stroke-dashoffset: 0;\n        }\n        &:before {\n          transform: scale(3.5);\n          opacity: 0;\n          transition: all .6s ease;\n        }\n      }\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  .indent {\n    * > p.no-errors {\n        display: none;\n      }\n    }\n'], ['\n  .indent {\n    * > p.no-errors {\n        display: none;\n      }\n    }\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { keyframes } from 'styled-components';

var wave = function wave(props) {
  return keyframes(_templateObject);
};

var SimplyCheckbox = styled.div(_templateObject2, function (props) {
  return props.enforceMaxWidth === false ? 'initial' : 'calc(100% - 40px)';
}, function (props) {
  return props.theme.border_width;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, wave);

var Checkbox = function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        labelText = _props.labelText,
        children = _props.children,
        id = _props.id,
        label = _props.label,
        enforceMaxWidth = _props.enforceMaxWidth,
        rest = _objectWithoutProperties(_props, ['labelText', 'children', 'id', 'label', 'enforceMaxWidth']);

    return React.createElement(SimplyCheckbox, {
      enforceMaxWidth: enforceMaxWidth
    }, React.createElement('input', _extends({
      type: 'checkbox',
      id: id
    }, rest)), React.createElement('label', {
      htmlFor: id
    }, React.createElement('span', null, React.createElement('svg', {
      width: '12px',
      height: '10px',
      viewBox: '0 0 12 10'
    }, React.createElement('polyline', {
      points: '1.5 6 4.5 9 10.5 1'
    }))), React.createElement('span', {
      className: 'children'
    }, children || labelText || label)));
  };

  return Checkbox;
}(React.Component);

export { Checkbox as default };
var CheckboxesContainer = styled.div(_templateObject3);
export var Checkboxes = function (_React$Component2) {
  _inherits(Checkboxes, _React$Component2);

  function Checkboxes() {
    _classCallCheck(this, Checkboxes);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Checkboxes.prototype.render = function render() {
    var children = this.props.children;
    return React.createElement(CheckboxesContainer, null, children);
  };

  return Checkboxes;
}(React.Component);